import { LoadingPage } from '@chiroup/components/LoadingPage';
import { Route, Routes, useParams } from 'react-router-dom';
import useTest from '../../../hooks/useTest';
import Header from '../../layout/Header';
import TestDetail from './TestDetail';

const TestDetailContainer = () => {
  const { itemId } = useParams();

  const { data, refetch, save, del, isDeleting, key } = useTest(itemId || '');

  return (
    <>
      <Header title="Test" />
      <Routes>
        <Route
          path="/"
          element={
            data ? (
              <TestDetail
                key={key}
                data={data}
                save={save}
                refetch={refetch}
                del={del.bind(null, data.ID)}
                isDeleting={isDeleting}
              />
            ) : (
              <LoadingPage />
            )
          }
        />
      </Routes>
    </>
  );
};

export default TestDetailContainer;
